import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { LaserBookApi } from '../Api/LaserBook';
import { Flip, toast } from 'react-toastify';
import NumberBetModal from './Numberbetmodal';
import { Helmet } from 'react-helmet';

export default function BetHistory() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [isClient, setIsClient] = useState("");
    const [selectedDate, setSelectedDate] = useState(() => new Date().toISOString().split("T")[0]);
    const [betHistoryData, setBetHistoryData] = useState([]);
    const { setLoad, setLoadColor, numberModal, sideBarOpen, sessionDetail } = useContext(Context);

    const handleClientChange = (e) => {
        const value = e.target.value;
        setIsClient(value);
    };

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };

    const handleBetHistory = useCallback(async () => {
        if (!isClient) {
            setBetHistoryData([]);
            return;
        }

        setLoad(true);
        setLoadColor("#434343");

        const userinfo = JSON.parse(localStorage.getItem('userinfo'));
        const data = {
            username: userinfo?.username,
            client_name: isClient,
            user_id: userinfo?.userId,
            date: selectedDate
        };

        try {
            const res = await LaserBookApi(data);
            if (res && res.data.status) {
                const result = res.data.data;
                if (isClient === "All Client") {
                    setBetHistoryData(result.hisab_kitab_all || []);
                } else {
                    setBetHistoryData(result.hisab_kitab ? [result.hisab_kitab] : []);
                }
            } else {
                setBetHistoryData([]);
                toast.error(res?.data?.message || "Something went wrong", {
                    position: "top-right",
                    autoClose: 1500,
                    theme: "colored",
                    transition: Flip,
                });
            }
        } catch (err) {
            console.error("API Error:", err);
            setBetHistoryData([]);
        } finally {
            setLoad(false);
        }
    }, [isClient, selectedDate, setLoad, setLoadColor]);

    useEffect(() => {
        if (pathname === "/hisabKitab" && !numberModal && !sideBarOpen) {
            handleBetHistory();
        }
    }, [pathname, numberModal, sideBarOpen, handleBetHistory]);

    useEffect(() => {
        if (isClient) {
            handleBetHistory();
        } else {
            setBetHistoryData([]);
        }
    }, [isClient, selectedDate, handleBetHistory]);

    return (
        <>
            <Helmet>
                {/* Page Title */}
                <title>Laser Book | Complete Client & Bazar Report | Matka Jantri</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="Access the Laser Book to view complete reports of all clients and Satta Bazar entries in one place. Designed for MatkaJantri owners and admins."
                />

                {/* SEO Directives */}
                <meta name="robots" content="noindex, nofollow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://app.matkajantri.com/laser-book" />

                {/* Favicon and Icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph */}
                <meta property="og:title" content="Laser Book | Complete Client & Bazar Report | MatkaJantri" />
                <meta
                    property="og:description"
                    content="Access the Laser Book to view complete reports of all clients and Satta Bazar entries in one place. Designed for MatkaJantri owners and admins."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://app.matkajantri.com" />
                <meta property="og:image" content="https://app.matkajantri.com/Logo.png" />
                <meta name="google-site-verification" content="d6d81656210c6db7" />
            </Helmet>

            <NumberBetModal />
            <div className='depositContainer'>
                <div className="wrapper" style={{ marginTop: "0px" }}>
                    <div className="section">
                        <div className="top_navbar" style={{ height: "60px" }}>
                            <div className="hamburger">
                                <button
                                    className='back_btn'
                                    onClick={() => navigate("/game")}
                                    style={{ background: 'none', border: 'none' }}
                                >
                                    <i className="fa-solid fa-chevron-left"></i>
                                </button>
                            </div>
                            <div className='gameName'>Laser Book</div>
                        </div>
                    </div>
                </div>

                <div className="Tablecontainer betHistorytableCss">
                    {/* Filter Section */}
                    <div className='SelectData'>
                        <div
                            className='container-Section'
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "20px",
                                justifyContent: "space-between",
                                padding: "10px 0"
                            }}
                        >
                            {/* Client Dropdown */}
                            <div style={{ flex: 1, minWidth: "220px" }}>
                                <label style={{ fontWeight: "bold" }}>Select Client</label>
                                <select
                                    className="select-dropdown"
                                    value={isClient}
                                    onChange={handleClientChange}
                                    style={{ width: "100%", padding: "8px", marginTop: "5px" }}
                                >
                                    <option value=''>Select Client</option>
                                    <option value="All Client">All Client</option>
                                    {sessionDetail?.user_clients?.map((client, index) => (
                                        <option key={index} value={client}>{client}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Date Picker */}
                            <div style={{ flex: 1, minWidth: "220px" }}>
                                <label style={{ fontWeight: "bold" }}>Select Date</label>
                                <input
                                    type="date"
                                    value={selectedDate}
                                    max={new Date().toISOString().split("T")[0]}
                                    onChange={handleDateChange}
                                    style={{ width: "98%", padding: "8px", marginTop: "5px" }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Always-visible table */}
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th style={{ textAlign: 'center' }}>
                                    <div>Profit (<span style={{ color: 'green' }}>++</span>)</div>
                                    <div>Loss (<span style={{ color: 'red' }}>--</span>)</div>
                                </th>

                                <th style={{ textAlign: 'center' }}>
                                    <div>Recive (<span style={{ color: 'green' }}>++</span>)</div>
                                    <div>Pay (<span style={{ color: 'red' }}>--</span>)</div>
                                </th>

                                <th>
                                    <span style={{ color: 'green' }}>Lain++</span> / <span style={{ color: 'red' }}>Dain--</span>
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    <div style={{ color: 'blue', fontWeight: 'bold' }}>Final</div>
                                    <div>
                                        <span style={{ color: 'green' }}>Lain++</span> / <span style={{ color: 'red' }}>Dain--</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>






                        <tbody>
                            {betHistoryData && betHistoryData.length > 0 ? (
                                betHistoryData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.date ? new Date(item.date).toLocaleDateString() : selectedDate || "--"}</td>
                                        <td style={{ color: item.profit_loss >= 0 ? 'red' : 'green ' }}>
                                            {Math.abs(item.profit_loss)}
                                        </td>

                                        <td

                                            style={{ color: item.recive_pay >= 0 ? 'green' : 'red' }}>
                                            {Math.abs(item.recive_pay) || "--"}

                                        </td>
                                        <td style={{ color: item.recive_pay >= 0 ? 'green' : 'red' }}>
                                            {Math.abs(item.recive_pay) || "--"}
                                        </td>
                                        <td style={{ color: (item.profit_loss + item.recive_pay) >= 0 ? 'red ' : 'green' }}>
                                            {Math.abs(item.profit_loss + item.recive_pay) || "--"}
                                        </td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center", padding: "20px", fontWeight: "500" }}>
                                        No data found pls select client and date
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div >
        </>
    );
}
